import React from "react";
import { connect } from "react-redux";
import { bool, shape } from "prop-types";
import classNames from "classnames";
import { selectors as fundcorpSelectors } from "reducers/fundcorp";
import Heading from "pages/_components/Heading";
import FormattedAmount from "pages/_components/FormattedAmount";
import FormattedDate from "pages/_components/FormattedDate";

function CancelSummaryData({ isDesktop, spaceBetween, summary }) {
    const {
        creditAccountLabel,
        idTransaction,
        submitDateTime,
        fondoNombre,
        amountToShow,
        fondoClase,
        cuotapartistaNumero,
        cancelDate,
    } = summary;

    if (!cuotapartistaNumero) {
        return <></>;
    }

    return (
        <>
            {submitDateTime && (
                <Heading.DataGroup
                    containerClassName={classNames("transfer-data data-wrapper-flex", {
                        "space-between": spaceBetween,
                    })}
                    label="forms.transaction.ticket.date"
                    labelClassName="no-wrap"
                    data={<FormattedDate date={submitDateTime} dateFormat="dd/MM/yyyy" showTime />}
                    dataClassName="data-desc"
                />
            )}
            {idTransaction && (
                <Heading.DataGroup
                    containerClassName={classNames("transfer-data data-wrapper-flex", {
                        "space-between": spaceBetween,
                    })}
                    label="forms.transaction.ticket.number"
                    labelClassName="no-wrap"
                    data={idTransaction.substring(0, 8).toUpperCase()}
                    dataClassName="data-desc"
                />
            )}
            {fondoNombre && (
                <Heading.DataGroup
                    containerClassName={classNames("transfer-data data-wrapper-flex", {
                        "space-between": spaceBetween,
                    })}
                    label="fund.cancel.summary.fund.label"
                    labelClassName="no-wrap"
                    data={`${fondoNombre}`}
                    dataClassName="data-desc"
                />
            )}

            {amountToShow && (
                <Heading.DataGroup
                    containerClassName={classNames("transfer-data data-wrapper-flex", {
                        "space-between": spaceBetween,
                    })}
                    label="fund.cancel.summary.subscribeAmount.label"
                    labelClassName="no-wrap"
                    data={
                        <FormattedAmount
                            {...amountToShow}
                            notBold
                            className={`${isDesktop ? "f-size-4" : "f-size-65"}`}
                        />
                    }
                    dataClassName="data-desc"
                />
            )}

            {fondoClase && (
                <Heading.DataGroup
                    containerClassName={classNames("transfer-data data-wrapper-flex", {
                        "space-between": spaceBetween,
                    })}
                    label="fund.cancel.summary.class.label"
                    labelClassName="no-wrap"
                    data={fondoClase}
                    dataClassName="data-desc"
                />
            )}

            {creditAccountLabel && (
                <Heading.DataGroup
                    containerClassName={classNames("transfer-data data-wrapper-flex", {
                        "space-between": spaceBetween,
                    })}
                    label="fund.cancel.summary.creditAccount.label"
                    labelClassName="no-wrap"
                    data={creditAccountLabel}
                    dataClassName="data-desc"
                />
            )}

            {cuotapartistaNumero && (
                <Heading.DataGroup
                    containerClassName={classNames("transfer-data data-wrapper-flex", {
                        "space-between": spaceBetween,
                    })}
                    label="fund.cancel.summary.shareAccount.label"
                    data={cuotapartistaNumero}
                    dataClassName="data-desc"
                />
            )}
            {cancelDate && (
                <Heading.DataGroup
                    containerClassName={classNames("transfer-data data-wrapper-flex", {
                        "space-between": spaceBetween,
                    })}
                    label="fund.cancel.summary.date.label"
                    labelClassName="no-wrap"
                    data={<FormattedDate date={cancelDate} dateFormat="dd/MM/yyyy" />}
                    dataClassName="data-desc"
                />
            )}
        </>
    );
}

CancelSummaryData.propTypes = {
    isDesktop: bool,
    spaceBetween: bool,
    summary: shape({
        selectedFund: shape({}),
    }).isRequired,
};

CancelSummaryData.defaultProps = {
    isDesktop: true,
    spaceBetween: false,
};

const mapStateToProps = (state) => ({
    summary: fundcorpSelectors.getSummary(state),
});

export default connect(mapStateToProps)(CancelSummaryData);
